import { render, staticRenderFns } from "./FormOtp.vue?vue&type=template&id=1203a8d0&"
import script from "./FormOtp.vue?vue&type=script&lang=js&"
export * from "./FormOtp.vue?vue&type=script&lang=js&"
import style0 from "./FormOtp.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports